import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import ForgotPasswordModal from './ForgotPasswordModal';

import {
    sendResetPasswordEmail as sendResetPasswordEmailAction,
    setResetPasswordEmailStatus as setResetPasswordEmailStatusAction,
} from '../../actions/forgotPassword';

import {
    trackOpenForgotPasswordModal as trackOpenForgotPasswordModalAction,
    trackCloseForgotPasswordModal as trackCloseForgotPasswordModalAction,
} from '../../actions/gaTracking';

import { clearAuthNotification as clearAuthNotificationAction } from '../../actions/auth';

import { LOG_IN_FORM } from '../../constants';

const _mapStateToProps = (state) => {
    const { status, social } = state;
    const { socialData: { apple, facebook, google } = {} } = social;

    const previousFormEmail =
        formValueSelector(LOG_IN_FORM)(state, 'email') ||
        apple?.email ||
        facebook?.email ||
        google?.email;

    return {
        resetPasswordEmailStatus: status.resetPasswordEmailStatus,
        usesNewStyles: true,
        previousFormEmail,
    };
};

const _mapDispatchToProps = {
    handleForgotPassword: sendResetPasswordEmailAction,
    setResetPasswordEmailStatus: setResetPasswordEmailStatusAction,
    clearAuthNotification: clearAuthNotificationAction,
    trackOpenForgotPasswordModal: trackOpenForgotPasswordModalAction,
    trackCloseForgotPasswordModal: trackCloseForgotPasswordModalAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(ForgotPasswordModal);
